import {mapActions, mapMutations } from 'vuex'
const PlayerUtils = {
    watch:{
        playerVolume () {
            this.changeVolume({volume: this.playerVolume})
        },
        progressPercent(){
            this.playerProgressPercent = this.progressPercent
        },
        timeLapse (value) {
            if((this.currentTrackDuration === 'NaN : NaN') || ((this.progressPercent === 'NaN') || (this.progressPercent === 0) || !(this.progressPercent))){ // fix to displaying track time 'NaN : NaN' & timeBufferMins being stuck at 0
                this.updateCountCheck({countCheck: 0})
            }
            if (value) {
                this.viewShit()
            }
        },
        volume(){
            this.playerVolume = this.volume
        },
        audio () {
            // changed Track
            this.currentTrackTime = parseInt(this.audio.currentTime);
            this.lastRecordedTrackTime = -1
        }
    },
    mounted(){
        let xns = this;
        setTimeout(function () {
            xns.updateLastSongId({lastSongId: xns.tracks.length - 1})
            xns.playerVolume = xns.getVolume
            xns.playerProgressPercent = xns.getProgressPercent
        }, 1000);
    },
    methods:{
        scrubChange(){
            this.scrubToTime(this.playerProgressPercent)
        },
        changeContinuousPlay(){
            this.updateContinuousPlay({status: !this.continuousPlay})
        },
        ...mapActions({
          viewShit: 'player/viewShit',
          playSong: 'player/playSong',
          play: 'player/play',
          nextSong: 'player/nextSong',
          prevSong: 'player/prevSong',
          stop: 'player/stop',
          scrubToTime: 'player/scrubToTime',
          updateTimeLapse: 'player/updateTimeLapse'
        }),

        ...mapMutations({
          changeVolume: 'player/changeVolume',
          updateCountCheck: 'player/updateCountCheck',
          updateAudioCurrentTime: 'player/updateAudioCurrentTime',
          updateLastSongId: 'player/updateLastSongId',
          changeAudioVolume: 'player/changeAudioVolume',
          updateContinuousPlay: 'player/updateContinuousPlay',
        })

        // changeVolume(payload) { this.$store.commit('player/changeVolume', payload) },
        // updateCountCheck(payload) { this.$store.commit('player/updateCountCheck', payload) },
        // updateAudioCurrentTime(payload) { this.$store.commit('player/updateAudioCurrentTime', payload) },
        // updateLastSongId(payload) { this.$store.commit('player/updateLastSongId', payload) },
        // changeAudioVolume(payload) { this.$store.commit('player/changeAudioVolume', payload) },
        // updateContinuousPlay(payload) { this.$store.commit('player/updateContinuousPlay', payload) },
    }
}

export default PlayerUtils;
